import { useEffect, useMemo, useState } from "react";
import { useFontDesk } from "../../context/frontDeskContext";
import "./ReedemLoyaltyPoints.css";
import { FrontDeskApi } from "../../apis/frontDesk.api";
import { useLocation, useNavigate } from "react-router-dom";
import LoadingIndicator from "../../components/loadingIndicator/LoadingIndicator";

interface DecodedData {
  Id: number;
  Name: string;
  UserId: string;
  PointsRequired?: number;
}
export const ReedemLoyaltyPointsDeeplink = () => {
  const { search } = useLocation();
  const { initialRoute, setInitialRoute } = useFontDesk();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<string | null>(null);
  const [decodedData, setDecodedData] = useState<DecodedData | null>(null);

  const base64Data = useMemo(() => {
    if (search) {
      const params = new URLSearchParams(search);
      const code = params.get("code");
      return atob(code ?? "");
    } else if (initialRoute?.includes("code")) {
      const code = initialRoute?.split("=")[1];
      return atob(code ?? "");
    }
  }, [search, initialRoute]);

  useEffect(() => {
    if (base64Data) {
      setDecodedData(JSON.parse(base64Data));
      setInitialRoute(null);
    } else {
      setError("Invalid or expired redemption code");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [base64Data]);

  useEffect(() => {
    setTimeout(() => {
      if (!search && !initialRoute?.includes("code")) {
        window.location.replace("/");
      }
    }, 1000);
    return () => {
      setInitialRoute(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleConfirm = async () => {
    if (!decodedData) return;

    try {
      setLoading(true);
      setError(null);
      setSuccess(null);

      const response = await FrontDeskApi.reedemLoyaltyQR(
        decodedData.Id,
        decodedData.UserId
      );
      console.log(response.status);
      if (response.status === 200) {
        setSuccess(
          "Reward successfully redeemed! The customer can now claim their reward."
        );
        // Auto-navigate after 3 seconds
        setTimeout(() => {
          navigate("/");
        }, 30000);
      } else {
        setError(
          "Unable to redeem the reward. The reward cannot be handed out at this time."
        );
      }
    } catch (err) {
      setError(
        "Unable to redeem the reward. The reward cannot be handed out at this time."
      );
    } finally {
      setLoading(false);
    }
  };

  const handleReject = () => {
    navigate("/");
  };

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100 p-3">
      <div className="card" style={{ maxWidth: "400px", width: "100%" }}>
        <div className="card-body">
          <h5 className="card-title mb-4">Loyalty Reward Redemption</h5>

          {error && (
            <div className="alert alert-danger mb-3">
              {error}
              <div className="mt-3">
                <button
                  className="btn btn-outline-primary"
                  onClick={() => navigate("/")}
                >
                  Try Again
                </button>
              </div>
            </div>
          )}

          {success && <div className="alert alert-success mb-3">{success}</div>}

          {decodedData && !error && !success && (
            <>
              <h6 className="card-subtitle mb-2">{decodedData.Name}</h6>
              {decodedData.PointsRequired && (
                <p className="card-text text-muted mb-3">
                  Points Required: {decodedData.PointsRequired}
                </p>
              )}

              <div className="d-flex justify-content-between mt-4">
                <button
                  className="btn btn-outline-danger"
                  onClick={handleReject}
                  disabled={loading}
                >
                  Reject
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleConfirm}
                  disabled={loading}
                >
                  Confirm
                </button>
              </div>
            </>
          )}
        </div>
      </div>
      <LoadingIndicator loading={loading} />
    </div>
  );
};
